'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var react = require('react');
var webVitals = require('web-vitals');
var useAnalyticsPost = require('./useAnalyticsPost.js');

const WebVitals = () => {
  const logEvent = useAnalyticsPost.useAnalyticsPost();
  react.useEffect(() => {
    const onReport = ({
      name,
      value
    }) => {
      logEvent({
        eventType: useAnalyticsPost.NarvarEventTypes.WEB_VITAL,
        eventId: name,
        pageLoadMs: value
      });
    };
    webVitals.onCLS(onReport);
    webVitals.onFCP(onReport);
    webVitals.onFID(onReport);
    webVitals.onLCP(onReport);
    webVitals.onTTFB(onReport);
  }, [logEvent]);
  return null;
};

exports.WebVitals = WebVitals;
